/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/SavedArticles/theme';

export const SavedArticlesTheme = theme;
